var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
export var SvgWrapper = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n"], ["\n  width: ", ";\n  height: ", ";\n"
// --- Helpers
])), function (_a) {
  var size = _a.size;
  return calcSize(size);
}, function (_a) {
  var size = _a.size;
  return calcSize(size);
});
// --- Helpers
var calcSize = function (size) {
  var amount = Number(size);
  return Number.isNaN(amount) ? '100%' : "".concat(amount, "px");
};
var templateObject_1;